import { useCallback } from 'react';
import useFetchReduxed from 'hooks/useFetchReduxed';
import useSateReduxed from 'hooks/useSateReduxed';
import { getPendingPayments } from '../actions';
import { reducers } from '../constants';
export const useThankedPayment = () => useSateReduxed(reducers.THANKED_PAYMENT);
export const useRemindedRequest = () => useSateReduxed(reducers.REMINDED_REQUEST);
export const usePendingPayments = () => {
    const [result, error, busy, fetch] = useFetchReduxed(reducers.PENDING_PAYMENTS);
    const pendingFetch = useCallback((force = false) => {
        const now = new Date().getTime();
        if (force ||
            !usePendingPayments.lastCallTime ||
            now - usePendingPayments.lastCallTime > 10 * 60 * 1000) {
            usePendingPayments.lastCallTime = now;
            fetch(getPendingPayments());
        }
    }, [fetch]);
    return [result, error, busy, pendingFetch];
};
usePendingPayments.lastCallTime = undefined;
